import { z } from "zod";

export const serviceProviderDtoSchema = z.object({
  id: z.number(),
  name: z.string(),
  manuallyTriggeredAppointmentAllowed: z.boolean().nullable(),
});

export type TServiceProviderDto = z.infer<typeof serviceProviderDtoSchema>;
